import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';

// Derived from the prototype `.dl` rows, reshaped for wide cards: the
// prototype's space-between put the value at the far edge — unreadable past
// ~500px. A fixed label column keeps key and value adjacent at any width.
export const styles = {
  list: {
    kogj98: "x1ghz6dp",
    k1xSpc: "x1lliihq",
    $$css: true
  },
  row: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x7okntf",
    kGNEyG: "x6s0dn4",
    k1C7PZ: "x1ox4up4",
    kmVPX3: "x1b4vry6",
    kAzted: "xgujvf1",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    kTFOXF: "x14tvv71",
    $$css: true
  },
  term: {
    kMv6JI: "xpc6l4x",
    kGuDYH: "x1j6dyjg",
    k63SB2: "xomqrzn",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  val: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1nhvcw1",
    kwnvtZ: "x1a02dak",
    kOIVth: "x167g77z",
    k9WMMc: "xdpxx8g",
    kGuDYH: "xif65rj",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  valMono: {
    kMv6JI: "x1gs96k",
    kGuDYH: "x4z9k3i",
    k63SB2: "xssbmp7",
    $$css: true
  },
  rowPlain: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xr8bkws xxhsi6u",
    k1C7PZ: "xw5r5fb",
    khm7nJ: "xzs24ji",
    k8WAf4: "x1rfhzvs",
    kGNEyG: "x1pha0wt",
    $$css: true
  },
  termPlain: {
    kogj98: "x1ghz6dp",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  valPlain: {
    kogj98: "x1ghz6dp",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1fwedmp",
    kGuDYH: "x2pyw9z",
    k63SB2: "x1fm9vgf",
    kMwMTN: "x1oezkus",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  valPlainMono: {
    kMv6JI: "x1gs96k",
    $$css: true
  }
};